var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resources__el"},[_c('div',{staticClass:"resources__title"},[_c('h2',[_vm._v(_vm._s(_vm.section.title))]),_vm._v(" "),_c('div',{staticClass:"resources__list"},_vm._l((_vm.section.resources_list),function(item){return _c('resources-item',{key:item.icon.title,attrs:{"item":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }